// extracted by mini-css-extract-plugin
export default {"container":"MainHeader_container__kya5o","menu":"MainHeader_menu__NpLet","icon":"MainHeader_icon__pePN5"};